<template>
	<div class="text-style-editor flex-space-between--center">
		<div class="text-field-container flex-1">
			<TextField :autofocus="autofocus" v-model="textValue" :readonly="readonly" :isPiggyback="isPiggyback" />
		</div>
		<div class="flex-centerize" v-if="!nativeEditor">
			<FontSizeSelect class="mr-4" :fontSize.sync="textFontSize" :disabled="!textValue || readonly" />
			<ColorPicker title="Text Color" :color.sync="textColor" :iconName="'background-sample-icon'" :disabled="!textValue || readonly" />
		</div>
	</div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker/ColorPicker';
import FontSizeSelect from '../FontSizeSelect.vue';
import TextField from '../TextField.vue';

export default {
	name: 'TextStyleEditor',
	components: {
		ColorPicker,
		FontSizeSelect,
		TextField,
	},
	props: {
		btnSettings: { type: Object },
		isPiggyback: { type: Boolean },
		nativeEditor: {
			type: Boolean,
			default: false,
		},
		autofocus: {
			type: Boolean,
			default: false,
		},
		readonly: { type: Boolean, default: false },
	},
	computed: {
		textBtnSettings: {
			get() {
				return this.btnSettings.text;
			},
			set(value) {
				this.updateBtnSettings(Object.assign({ ...this.btnSettings }, { text: value }));
			},
		},
		textFontSize: {
			get() {
				return this.textBtnSettings.fontSize;
			},
			set(value) {
				this.textBtnSettings = Object.assign({ ...this.textBtnSettings }, { fontSize: value });
			},
		},
		textColor: {
			get() {
				return this.textBtnSettings.color;
			},
			set(value) {
				this.textBtnSettings = Object.assign({ ...this.textBtnSettings }, { color: value });
			},
		},
		textValue: {
			get() {
				return (this.textBtnSettings || {}).value;
			},
			set(value) {
				const shouldSetIcon = this.btnSettings?.icon?.name && this.btnSettings.icon.name !== 'ply-element-transparent' && this.isPiggyback;
				if (!shouldSetIcon) {
					this.textBtnSettings = Object.assign({ ...this.textBtnSettings }, { value });
				} else {
					const transparentIconData = { ...this.btnSettings.icon, name: 'ply-element-transparent' };
					this.updateBtnSettings(
						Object.assign({ ...this.btnSettings }, { icon: transparentIconData, text: { ...this.textBtnSettings, value } })
					);
				}
			},
		},
	},
	methods: {
		updateBtnSettings(payload) {
			this.$emit('update:btnSettings', payload);
		},
	},
};
</script>
<style scoped lang="scss">
.text-style-editor {
	> div:not(:last-child) {
		margin: 0 10px 0 0;
	}

	::v-deep {
		.text-field {
			padding: 5px;
		}
	}
}
</style>
